import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "image-viewer" }

import { ElImageViewer } from "element-plus";
	
	
	
export default /*@__PURE__*/_defineComponent({
  __name: 'ImageViewer',
  props: {
    list: {},
    showViewer: { type: Boolean },
    index: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

	const emit = __emit

	const props = __props;
	
	const close = () => {
		props.showViewer = false
		emit('close')
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.showViewer)
      ? (_openBlock(), _createBlock(_unref(ElImageViewer), {
          key: 0,
          "initial-index": _ctx.index,
          onClose: close,
          "url-list": props.list
        }, null, 8, ["initial-index", "url-list"]))
      : _createCommentVNode("", true)
  ]))
}
}

})